namespace Tutorial {
	let arrow: PIXI.Sprite;

	export function start() {
		arrow = new PIXI.Sprite(Assets.ui.arrow);
		arrow.pivot.set(26, 233);

		this.active = true;

		App.stage.addChild(arrow);
		update();
		Game.shotEnabled = false;
	}

	function showArrow(obj: any) {
		obj.toGlobal(new PIXI.Point(0, 0), arrow.position);
		obj.tutored = true;
	}


	let step = 0;

	export function update() {
		if (step < 0) {
			step = 0;
		}
		if (step >= 10) {
			end();
		}

		switch (step) {
			case 0:
				showArrow(Game.bases[24]);
				break;
			case 1:
				showArrow(Interact.shopTower.tw[0]);
				break;
			case 2:
				showArrow(Game.bases[23]);
				break;
			case 3:
				showArrow(Interact.shopTower.tw[0]);
				break;
			case 4:
				showArrow(Game.bases[25]);
				break;
			case 5:
				showArrow(Interact.shopTower.tw[0]);
				break;
			case 6:
				showArrow(Game.bases[17]);
				break;
			case 7:
				showArrow(Interact.shopTower.tw[1]);
				break;
			case 8:
				showArrow(Game.bases[17]);
				break;
			case 9:
				showArrow(Interact.shopRepair.upgrade);
				break;
		}
	}

	export function prev() {
		step--;
		update();
	}

	export function next() {
		step++;
		update();
	}

	export function end() {
		App.stage.removeChild(arrow);
		active = false;
		Game.shotEnabled = true;
	}

	export let active = false;
}
